import React from 'react';
import { useQuizSummary } from '../context/QuizSummaryContext';

const QuizSummary = () => {
  const { summary, loading, error } = useQuizSummary();

  const summaryStyle = {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '1rem',
    padding: '4px 4px',
    color: 'antiquewhite',
    flexWrap: 'wrap',
    fontSize: '0.875rem',
    lineHeight: '0.50rem',
  };

  const statStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.4rem',
  };

  if (loading) {
    return <div style={{ ...summaryStyle, justifyContent: 'center' }}>Loading summary...</div>;
  }

  if (error) {
    return <div style={{ ...summaryStyle, justifyContent: 'center', color: 'red' }}>{error}</div>;
  }

  return (
    <div className="quiz-summary-header" style={summaryStyle}>
      <span>Quiz Summary</span>
      <div style={statStyle}>
    
        <span>Attempted:</span>
        <strong>{summary.answeredQuestions}/{summary.totalQuestions}</strong>
      </div>
      <div style={statStyle}>
        <span>Remaining:</span>
        <strong>{summary.pendingQuestions}</strong>
      </div>
    </div>
  );
};

export default QuizSummary;